import axios from '@/libs/api.request';
//充值方式手续费费率列表
export const getBandServiceFeeRateList = data => {
    return axios.request({
        url: 'api/financeManagement/bankRecord/getBandServiceFeeRateList',
        data: data,
        method: 'post'
    });
};
//充值方式手续费费率修改记录列表
export const getBandServiceFeeRateRecordList = data => {
    return axios.request({
        url: 'api/financeManagement/bankRecord/getBandServiceFeeRateRecordList',
        data: data,
        method: 'post'
    });
};
//保存充值方式手续费费率
export const saveBandServiceFeeRate = data => {
    return axios.request({
        url: 'api/financeManagement/bankRecord/saveBandServiceFeeRate',
        data: data,
        method: 'post'
    });
};
